import { Title } from "@mantine/core";
import { L2KH6Props } from "./types";
import { H6_STYLE, COLORS } from "./constants";

/**
 * L2KH6 - Sixth level heading component
 * Renders as <h6> by default, uses Big Shoulders Display font
 * Responsive sizing: 16px → 18px across 320px → 1920px viewports
 */
export function L2KH6({
  children,
  variant = "primary",
  component = "h6",
  style,
  ...props
}: L2KH6Props) {
  return (
    <Title
      order={6}
      component={component}
      style={{
        fontSize: H6_STYLE.fontSize,
        lineHeight: H6_STYLE.lineHeight,
        letterSpacing: H6_STYLE.letterSpacing,
        fontWeight: H6_STYLE.fontWeight,
        fontFamily: H6_STYLE.fontFamily,
        margin: 0,
        color: COLORS[variant],
        ...style,
      }}
      {...props}
    >
      {children}
    </Title>
  );
}
